<motif-footer>
  <div class="footer-content">
    <div class="left">
      <div class="footer-logo">
        <img [ngSrc]="logoURL()" alt="Logo" height="148" priority width="140" />
      </div>
    </div>

    <div class="right">
      <p>
        @if (privacyNoticeLinkAvailable()) {
          <button (click)="showPrivacyPolicy()" color="link-alt" motifButton size="small" type="button">
            {{ 'common.footer.privacy-notice' | translate }}
          </button>
          <br />
        }
        ©{{ currentYear }} {{ 'common.footer.all-rights-reserved' | translate }}<br />
        {{ 'common.footer.content-warning-info' | translate }}<br />
      </p>
    </div>
  </div>
</motif-footer>
